<template>
  <div>
    <div class="input__group input__add__info">
      <label :for="`expert-purpose-type-category-input-${index}`" class="label">{{ $lang.app.PURPOSE_OF_OBJECT }}</label>
      <div class="select__wrapper">
        <Field :name="`payments[${index}].expertPurposeTypeCategory`" v-slot="{ field, errorMessage }">
          <Multiselect
              :id="`expert-purpose-type-category-input-${index}`"
              :class="{'select--fail': errorMessage }"
              v-bind="field"
              v-model="$props.payment.expertPurposeTypeCategory"
              :options="helper.expertPurposeTypeCategoryOptions"
              :placeholder="$lang.app.SELECT_FROM_OPTIONS"
              :searchable="true"
              :noOptionsText="$lang.app.LIST_EMPTY"
              :noResultsText="$lang.app.NOT_FOUND"
              :can-clear="false">
          </Multiselect>
          <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
        </Field>
      </div>
    </div>

    <div class="input__group input__add__info">
      <label :for="`expert-purpose-type-input-${index}`" class="label">{{ $lang.app.PURPOSE_OF_OBJECT_TYPE }}</label>
      <div class="select__wrapper">
        <Field :name="`payments[${index}].expertPurposeType`" v-slot="{ field, errorMessage }">
          <Multiselect
              :id="`expert-purpose-type-input-${index}`"
              :class="{'select--fail': errorMessage }"
              v-bind="field"
              v-model="$props.payment.expertPurposeType"
              :options="helper.expertPurposeTypeOptions"
              :placeholder="$lang.app.SELECT_FROM_OPTIONS"
              :searchable="true"
              :noOptionsText="$lang.app.LIST_EMPTY"
              :noResultsText="$lang.app.NOT_FOUND"
              :can-clear="false">
          </Multiselect>
          <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
        </Field>
      </div>
    </div>

    <div class="input__group">
      <label :for="`description-input-${index}`" class="label">{{ $lang.app.NAME_OF_CALCULATION }}</label>
      <Field :name="`payments[${index}].description`" v-slot="{ field, errorMessage }">
        <input v-bind="field"
               type="text"
               :id="`description-input-${index}`"
               v-model="$props.payment.description"
               class="input"
               :class="{'input--fail': errorMessage }"
               :placeholder="$lang.app.ENTER">
        <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
      </Field>
    </div>

    <div class="flex">
      <div class="w-1/2 pr-1">
        <div class="input__group">
          <label :for="`value-input-${index}`" class="label">{{ $lang.app.VALUE }}</label>
          <Field :name="`payments[${index}].value`" v-slot="{ field, errorMessage }">
            <input v-bind="field"
                   type="number"
                   :id="`value-input-${index}`"
                   v-model="$props.payment.value"
                   class="input"
                   :class="{'input--fail': errorMessage }"
                   :placeholder="$lang.app.ENTER">
            <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
          </Field>
        </div>
      </div>
      <div class="w-1/2 pl-1">
        <div class="input__group input__add__info">
          <label :for="`unit-of-measurement-input-${index}`" class="label">{{ $lang.app.UNIT_OF_MEASUREMENT }}</label>
          <div class="select__wrapper">
            <Field :name="`payments[${index}].unitOfMeasurement`" v-slot="{ field, errorMessage }">
              <Multiselect
                  :id="`unit-of-measurement-input-${index}`"
                  :class="{'select--fail': errorMessage }"
                  v-bind="field"
                  v-model="$props.payment.unitOfMeasurement"
                  :options="helper.unitOfMeasurements"
                  :placeholder="$lang.app.SELECT_FROM_OPTIONS"
                  :searchable="true"
                  :noOptionsText="$lang.app.LIST_EMPTY"
                  :noResultsText="$lang.app.NOT_FOUND"
                  :can-clear="false">
              </Multiselect>
              <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
            </Field>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import expertPurposeTypeApi from "../../../../api/employee/expertPurposeType";
import expertPurposeTypeCategoryApi from "../../../../api/employee/expertPurposeTypeCategory";
import {Field} from "vee-validate";
import unitOfMeasurementApi from "../../../../api/ref/unitOfMeasurement";

export default {
  props: {
    payment: Object,
    index: Number,
  },
  components: {
    Field,
  },
  data() {
    return {
      helper: {
        expertPurposeTypeCategoryOptions: [],
        expertPurposeTypeOptions: [],
        unitOfMeasurements: [],
      },
    }
  },
  created() {
    this.initExpertPurposeTypeCategoryOptions()
    this.initUnitOfMeasurement()
  },
  watch: {
    'payment.expertPurposeTypeCategory'(value) {
      this.$props.payment.expertPurposeType = null
      if(value) {
        this.initExpertPurposeTypeOptions(value)
      }
    },
  },
  methods: {
    initExpertPurposeTypeCategoryOptions() {
      expertPurposeTypeCategoryApi.getExpertPurposeTypeCategories().then(res => {
        this.helper.expertPurposeTypeCategoryOptions = res.map(item => ({
          value: item.id,
          label: item.title
        }))
      })
    },
    initExpertPurposeTypeOptions(expertPurposeTypeCategoryId) {
      expertPurposeTypeApi.getExpertPurposeTypeCategoryExpertPurposeTypes(expertPurposeTypeCategoryId)
          .then(res => {
            this.helper.expertPurposeTypeOptions = res.map(item => ({
              value: item.id,
              label: item.title
            }))
          })
    },
    initUnitOfMeasurement() {
      unitOfMeasurementApi.getUnitOfMeasurements()
          .then(res => {
            this.helper.unitOfMeasurements = res.map(item => ({
              value: item.id,
              label: item.name
            }))
          })
    }
  }
}
</script>
